/**
 * A global namespace for 'transitionend' string.
 * @type {string}
 */
const transitionEndEvent = 'transitionend';
export default transitionEndEvent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/strings/transitionEndEvent.js
// module id = 12
// module chunks = 0